import { ConnectProto } from "@racoon/api";
import { STATUS_TONE_HEX, enumColors } from "@racoon/lib";

/** Figma outlines the pale assigned pin in its number's blue, or it fades into the map. */
export const jobStatusPinStroke = (status: ConnectProto.JobStatus): string | undefined =>
  jobStatusTone(status)?.bg === "bg-tone-assigned" ? STATUS_TONE_HEX.assigned.text : undefined;

/** The text-colour class of a job status's tone; every `text-tone-*` is safelisted. */
export const jobStatusTextClass = (status: ConnectProto.JobStatus): string | undefined =>
  jobStatusTone(status)?.bg?.replace(/^bg-/, "text-");

export const jobStatusTone = (status: ConnectProto.JobStatus) => {
  const name = ConnectProto.JobStatusSchema.values[Number(status)]?.name;
  return name ? enumColors[name as keyof typeof enumColors] : undefined;
};
